var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('img', {
    staticClass: "lazy-image",
    class: {
      loaded: _vm.loaded
    },
    attrs: {
      "src": _vm.srcHttps()
    },
    on: {
      "load": _vm.handleImageLoaded
    }
  });
};
var staticRenderFns = [];
export { render, staticRenderFns };